export default __webpack_public_path__ + "static/media/menu_dash.0e5df598.svg";